import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-slider',
  templateUrl: './payment-slider.component.html',
  styleUrls: ['./payment-slider.component.scss']
})
export class PaymentSliderComponent implements OnInit {
sliderData:any[]=[];
currentIndex:number=0;
imgSrc:string='';
  constructor() { }

  ngOnInit(): void {
    this.sliderData = sliderData;
    this.imgSrc = this.sliderData[0].imageURL;
  }
  move(direction:-1|1){
    if(direction<0 && this.currentIndex > 0){
      this.currentIndex = this.currentIndex -1;
      this.imgSrc = this.sliderData[this.currentIndex].imageURL;
      
    }else if(direction>0 && this.currentIndex < 3){
      this.currentIndex = (this.currentIndex + 1)%3 ;
      this.imgSrc = this.sliderData[this.currentIndex].imageURL;
    }
  }
}
export const sliderData = [
  { imageURL: 'sliderImg.png', text: 'Customize checkout to match brand & preferences with our payment gateway service.'},
  { imageURL: 'sliderImg2.png', text: 'Fraud prevention: 3D Secure & CVV verification tools included in our payment gateway service.'},
  { imageURL: 'sliderImg3.png', text: 'Our payment gateway service provides fast settlement times, ensuring that you receive your funds quickly and can focus on growing your business.'},
]